const deployment = {
    APP_NAME: 'Aldoo',
    PLATFORM_API_URL: 'https://aldoo.com',
    // the API shares aldoo.com with the site server, whose own sockets are on /socket.io
    REALTIME_PATH: '/rt-io',
    INTERNAL_API_URL: 'http://127.0.0.1:7068',
    API_URL: 'https://aldoo.com',
    PLATFORM_API_VERSION: 'v1',
    STRIPE_API_KEY: 'pk_live_51KHlvMDqI0V60CRML2VsmmU7IlOLHaLEpFd6QGWtY7Y82HfApsxMSkm4C1EIzgH0xXT5puVRUo8vt1w075qxTLzC00OT57Wgj1',
    APP_DOMAIN: 'aldoo.com',
    GTM_ID: "",
    FACEBOOK_PIXEL: "",
    FACEBOOK_OPTIONS: false,
    TRACKING_GDPR: false,
    GOOGLE_ANALYTICS_ID: "",
    API_DIAGNOSTICS: false,
    ENCRYPTION_ENABLED: false,
    INFLIGHT_ENCRYPTION_KEY: "",
};
export default deployment;
